export default __webpack_public_path__ + "static/media/article-5.94ed5896.webp";